import AllergiesandMedication from "../../Components/PatientDetails/Components/AllergiesandMedication/AllergiesandMedication";
import ConsultationHistory from "../../Components/PatientDetails/Components/Consultation History/ConsultationHistory";
import ConsultationDetails from "../../Components/PatientDetails/Components/ConsultationDetails/ConsultationDetails";
import LifestyleAndPreExistingCondition from "../../Components/PatientDetails/Components/LifestyleAndPreExistingCondition/LifestyleAndPreExistingCondition";
import BloodPressure from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/Blood Pressure/BloodPressure";
import SPO2 from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/SPO2/Spo2";
import Temperaturevlt from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/Temperature/Temperature";

import Glucose from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/Glucose/Glucose";
import PulseVital from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/PulseVital/PulseVital";
import ECG from "../../Components/PatientDetails/Components/Patient Vitals V2/Components/ECG/ECG";
import PatientVitalsV2 from "../../Components/PatientDetails/Components/Patient Vitals V2/PatientVitalsV2";
import PatientVitals from "../../Components/PatientDetails/Components/Patient Vitals/PatientVitals";
import PatientDetailsHeader from "../../Components/PatientDetails/Components/PatientDetailsHeader/PatientDetailsHeader";
import PersonalHealthCare from "../../Components/PatientDetails/Components/PersonalHealthCare/PersonalHealthCare";
//import RpmProfile from "../../Components/PatientDetails/Components/RpmProfileold/RpmProfile";
import SettingsComponent from "../../Components/PatientDetails/Components/SettingsComponent/SettingsComponent";
import PatientDetails from "../../Components/PatientDetails/PatientDetails";
import BloodPressuresetings from "../../Components/PatientDetails/Components/SettingsComponent/Components/BloodPressure/BloodPressure";
import Spo2 from "../../Components/PatientDetails/Components/SettingsComponent/Components/SPO2/Spo2";

import Pulsesettings from "../../Components/PatientDetails/Components/SettingsComponent/Components/Pulse/Pulse";
import GlucoseSettings from "../../Components/PatientDetails/Components/SettingsComponent/Components/Glucose/Glucose";
import EcgSettings from "../../Components/PatientDetails/Components/SettingsComponent/Components/ECG/Ecg";
import Temperature from "../../Components/PatientDetails/Components/SettingsComponent/Components/Temperature/Temperature";
//import ManageUsers from "../../Components/ManageUsers/ManageUsers";   
import ActionRequired from "../../Components/Other Components/ActionRequired";
import LifestyleAndPreExistingConditionPatient from "../../../PatientDashboard/Components/LifestyleAndPreExistingCondition/LifestyleAndPreExistingCondition";
import AllergiesandMedicationPatient from "../../../PatientDashboard/Components/AllergiesandMedication/AllergiesandMedication";


export const RpmHomeSideMenus = [
    {
        tittle:"Patients",
        options:[
            // {
            //     name:"Patient Details",
            //     ico:<i class="fal fa-book-medical"></i>,
            //     component:"patientdetails",
            //     date:"10, February, 2021 - Wednesday",
            //     header:<PatientDetailsHeader/>
            // },
            {
                name:"Add New Patient",
                ico:<i class="far fa-calendar-alt"></i>,
                component:"scheduleAppintment"

            },
            
        ]
    },
    {
        tittle: "Settings",
        options: [
            {
                name: "Manage Users",
                title:  "manageUsers",
                ico: <i class="fal fa-book-medical"></i>,
                component: "manageUsers",
                date: "10, February, 2021 - Wednesday"
            },
            {
                name: "Packages",
                ico: <i class="far fa-calendar-alt"></i>,
                component: "packages"

            },
            {
                name: "Settings",
                ico: <i class="far fa-calendar-alt"></i>,
                component: "settings"

            },

        ]
    
    },
]


// export const interbranchHomeSideMenu=[
//     {
//         tittle:"APPOINTMENT",
//         options:[
//             {
//                 name:"Book & Consult Now",
//                 ico:<i class="fal fa-book-medical"></i>,
//                 component:<BookConsultNow/>,
//                 date:"10, February, 2021 - Wednesday"
//             },
//             {
//                 name:"Schedule Appointment(s)",
//                 ico:<i class="far fa-calendar-alt"></i>,
//                 component:<ScheduleAppointment/>

//             },
//             {
//                 name:"Appointment History",
//                 ico:<i class="fal fa-calendar-check"></i>,
//                 component:<AppoinmentHistory/>
//             },
//         ]
//     },
//     {
//         tittle:"PATIENTS",
//         options:[
//             {
//                 name:"Patient Details",
//                 ico:<i class="far fa-user-circle"></i>,
//                 component:<PatientDetails/>
//             },
//         ]
//     },
//     {
//         tittle:"SETTINGS",
//         options:[
//             {
//                 name:"FAQ",
//                 ico:<i class="fal fa-question"></i>
//             },
//             {
//                 name:"Test my system",
//                 ico:<i class="fal fa-clipboard-list"></i>
//             },
//             {
//                 name:"I need help",
//                 ico:<i class="fas fa-info-circle"></i>
//             },
//         ]
//     },
    
// ]


export const l2navoptions=[
    //  {
    //     name:"Action Required",
    //     component:"actionrequired"
    // }, 
    // {
    //     name:"Patient Vitals",
    //     component:"patientvitals"
    // },
    
    //   {
    //     name:"Consultation History",
    //     component:"consultationhistory"
    // },  
    {
        name:"Profile",
        component:"profile"
    },
    // {
    //     name:"Personal Health Record",
    //     component:"healthrecords"
    // },
   
    // {
    //     name:"Settings",
    //     component:"settings"
    // },
    // {
    //     name:"Audit Log(s)",
    //     component:"auditlog"
    // }, 
   
]

export const l3navoptions=[
    /* {
        name:"Pulse",
        component:<PulseVital/>
    }, */
    {
        name:"Glucose",
        component:<Glucose/>,
    },
    {
        name:"SpO2",
        component:<SPO2/>
    },
    {
        name:"Blood Pressure",
        component:<BloodPressure/>
    },
    {
        name:"Body Temperature",
        component:<Temperaturevlt/>
    },
    {
        name:"Echo Cardiogram (ECG)",
        component:<ECG/>
    },
   
]

export const settingsoption=[
    // {
    //     name:"Pulse",
    //     component:<Pulsesettings/>
    // },
    {
        name:"Glucose",
        component:<GlucoseSettings/>
    },
    {
        name:"SpO2",
        component:<Spo2/>
    },
    {
         name:"Blood Pressure",
         component:<BloodPressuresetings/>
    },
    {
        name:"Body Temperature",
        component:<Temperature/>
    },
    // {
    //     name:"Echo Cardiogram (ECG)",
    //     component:<EcgSettings/>
    // },
   
]

export const l2PersonalHealthRecordsOPtions=[
    {
        name:"Lifestyle Conditions & Pre-Existing Conditions",
        component:<LifestyleAndPreExistingCondition/>
    },
    {
        name:"Medications & Allergies",
        component:<AllergiesandMedication/>
    },
    
]


export const PatientPersonalHealthRecordsOPtions=[
    {
        name:"Lifestyle Conditions & Pre-Existing Conditions",
        component:<LifestyleAndPreExistingConditionPatient/>
    },
    {
        name:"Medications & Allergies",
        component:<AllergiesandMedicationPatient/>
    },
    
]





export const yesNoOptions=["Yes", "No"]

export const familyOption=["Both", "Mother", "Father","None"]

export const relationOption=["Both", "Mother", "Father"]

export const allergentOptions=["Send SMS", "Send Notification", "Call Ambulance", "No Action"]
export const Actions=["Send SMS", "Send Notification", "Call Ambulance", "No Action"]
export const Actionstotake=["Send SMS", "Send Notification", "Call Ambulance", "No Action"]
export const EmergencyLevel=["Level 1","Level 2", "Level 3", "Level 4"]
export const AmbulanceTypes=["Type 1","Type 2", "Type 3", "Type 4"]
export const category=["Adult", "Child"]
export const Marriagestatus=["Single", "Married","Divorced","Separated","Widowed"]

export const gender=["Male","Female", "Other"]
export const Insuranceproviders=["Aditya Birla Health","alankit","ATMS","Bajaj Allianz","bharti ASSIST GLOBAL","Chola MS","Cigna","Cigna TTK","ERICSON TPA","Family Health Plan TPA","Future Generali","Good Health TPA","HDFC ERGO","HealthIndia TPA","Heritage Health","ICICI Lombard","ICICI Prudential","IFFCO_TOKIO","Liberty General Insurance","MAX Bupa","MD India","Medi Assist","MedSave India","Meera Rescue","Paramount Health","Raksha","Reliance General Insurance","Religare","STAR Health Insurance","United Healthcare","Universal Sompo","VIDAL HEALTH","Vipul MedCorp TPA"]
//export const relationship=["Single", "Married"]
export const relationship = [
    "Father",
    "Mother",
    "Brother",
    "Sister",
    "Son",
    "Daughter",
    "Grandfather",
    "Grandmother",
    "Friend",
    "Wife",
    "Husband",
    "Cousin",
    "Aunt",
    "Uncle",
    "Other",
  ];
export const occupation=["Single", "Married"]

export const sinceOptions=["1 Month", "2 Months", "6 Months"]

export const medicinesOptions=["Dolo", "Medicine 1", "Medicine2"]

export const heightUnits = ["Inches", "Feet", "Centemeter"]

export const weightUnits=['kg', 'lbs']

export const bloodGroups=["A+",	"A-",	"B+",	"B-",	"O+",	"O-",	"AB+",	"AB-"]

export const tempratureUnit=['Celsius', 'Fahrenheit']

export const pulseRateUnit=['Beats/Min']